export const GET_GURU_REQUEST = "guru/get/request";
export const GET_GURU_SUCCEED = "guru/get/succeed";
export const GET_GURU_FAILED = "guru/get/failed";

export const CREATE_GURU_REQUEST = "guru/create/request";
export const CREATE_GURU_SUCCEED = "guru/create/succeed";
export const CREATE_GURU_FAILED = "guru/create/failed";

export const DELETE_GURU_REQUEST = "guru/delete/request";
export const DELETE_GURU_SUCCEED = "guru/delete/succeed";
export const DELETE_GURU_FAILED = "guru/delete/failed";

export const GET_BY_ID_GURU_REQUEST = "guru/getid/request";
export const GET_BY_ID_GURU_SUCCEED = "guru/getid/succeed";
export const GET_BY_ID_GURU_FAILED = "guru/getid/failed";

export const GET_BY_RUMAHTAHFIDZ_GURU_REQUEST = "guru/getrumahtahfidz/request";
export const GET_BY_RUMAHTAHFIDZ_GURU_SUCCEED = "guru/getrumahtahfidz/succed";
export const GET_BY_RUMAHTAHFIDZ_GURU_FAILED = "guru/getrumahtahfidz/failed";

export const GET_BY_MASTERTAHFIDZ_GURU_REQUEST =
  "guru/getbymastertahfidz/request";
export const GET_BY_MASTERTAHFIDZ_GURU_SUCCEED =
  "guru/getbymastertahfidz/succed";
export const GET_BY_MASTERTAHFIDZ_GURU_FAILED =
  "guru/getbymastertahfidz/failed";

export const UPDATE_GURU_REQUEST = "guru/update/request";
export const UPDATE_GURU_SUCCEED = "guru/update/succeed";
export const UPDATE_GURU_FAILED = "guru/update/failed";

export const UPDATE_GURU_NOFILE_REQUEST = "guru/updatenofile/request";
export const UPDATE_GURU_NOFILE_SUCCEED = "guru/updatenofile/succeed";
export const UPDATE_GURU_NOFILE_FAILED = "guru/updatenofile/failed";
